import { useEffect } from 'react'
import { withAuth, withSituation } from 'wrappers'
import { PageLoader } from 'layouts/loaders'
import { STORE_STATUS_FINISHED } from 'constants/store'
import { useRedirect } from 'modules/navigation'
import { useUser } from 'modules/user'

const Redirect = () => {
  const { user } = useUser()
  const { redirectTo } = useRedirect()

  useEffect(() => {
    if (user.status === STORE_STATUS_FINISHED) {
      redirectTo()
    }
  }, [user.status])

  return <PageLoader />
}

const Component = withAuth(withSituation(Redirect))

export default Component
